export const NotificationType = {
  Message: 'messages',
  DoseSpot: 'dosespot',
  QuestLabQuestionnaire: 'quest_lab_questionnaire',
  ReassignedPatient: 'reassigned_patient',
  PatientUpdatedCBO: 'patient_updated_cbo',
  Availabilities: 'availabilities',
  NewAppointment: 'new_appointment',
  AppointmentScheduled: 'appointment_scheduled',
  CompleteScheduledHours: 'complete_scheduled_hours',
  CompletedQLinkLabTask: 'completed_qlink_lab_task',
  ExpiredQLinkResultTask: 'expired_qlink_result_task',
  ReportGeneration: 'report_generation',
  ReportCompletion: 'report_completion',
  ReportError: 'report_error',
  TaskCreation: 'task_creation',
  LicenseExpiration: 'license_expiration',
  EscalationTaskCreated: 'escalation_task_created',
  EscalationTaskReassigned: 'escalation_task_reassigned',
  EscalationTaskCompleted: 'escalation_task_completed',
  Generic: 'generic',
}
